export default "__VITE_ASSET__BOZkPs3U__"